<template>
  <section>
    <section-header
      @toggle="showSection = !showSection"
      @showSort="showSortModal = true"
      :showSection="showSection"
      :section="section"
      :showSort="true"
      :showAdd="true">
      <slot></slot>
    </section-header>

    <div class="content" v-show="showSection && items && items.length > 0">
      <trackable class="item-row"
        v-for="item in items"
        :item="item"
        :section="section"
        @setId="editId = item._id"
        :key="item._id">
      </trackable>
    </div>

    <ez-modal v-if="showEditModal" @close="closeEdit()" size="m-half">
      <h3>Trackable</h3>
      <default 
        :section="section" 
        :item="editItem">
      </default>
      <clone-delete-item
        :section="section"
        :item="editItem"
        @close="closeEdit()">
      </clone-delete-item>
    </ez-modal>

    <ez-modal v-if="showSortModal" @close="showSortModal = false" size="m-tiny">
      <h3>Trackables</h3>
      <sortable :section="section" :items="items"></sortable>
    </ez-modal>
  </section>
</template>
<script>
import { mapState } from "vuex";
import modal from "@/mixins/vue-ez-modal";
import CloneDeleteItem from "../shared/_CloneDeleteItem.vue";
import Default from "./_Default.vue";
import SectionHeader from "../shared/_SectionHeader.vue";
import Sortable from "../shared/_Sortable.vue";
import Trackable from "./_Trackable.vue";

export default {
  name: "sheet-trackables-index",
  mixins: [modal],
  components: {
    CloneDeleteItem,
    Default,
    SectionHeader,
    Sortable,
    Trackable
  },
  data() {
    return {
      section: "trackables",
      showSection: true,
      editId: null,
      editItem: null,
      showEditModal: false,
      showSortModal: false
    };
  },
  watch: {
    editId: "showEdit"
  },
  computed: {
    ...mapState({
      items: state => state.characters.current.trackables
    })
  },
  methods: {
    closeEdit() {
      this.showEditModal = false;
      this.editId = null;
    },
    showEdit() {
      if (this.editId) {
        this.editItem = this.items.find(x => x._id === this.editId);
        this.showEditModal = true;
      }
    }
  }
};
</script>
